module.exports = __webpack_public_path__ + "static/media/icon-produdctReference.28ed6ded.svg";